import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useState, useRef, useEffect } from 'react';
import strFunc from '@/lib/lyg/string';
import WordListArea from './area/word_list';

function TextBookManageWordPopupArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    g_par_id: "",
    g_par_seq: "",
    ...props
  };

  const [listOpt, setListOpt] = useState({
    "s_mcomp_seq": "",
    "s_g_par_id": myProps.g_par_id,
    "s_g_par_seq": myProps.g_par_seq,
    "order_id":"a_order_num",
    "is_need_count": "",
    "is_need_info_arr": "1",
    "is_no_limit": "1",
  });
  const [infoArr, setInfoArr] = useState([]);

  useEffect(() => {
    list({});
  }, []);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);

    if (strFunc.is_empty(tmp_list_opt.s_g_par_id)
      || strFunc.is_empty(tmp_list_opt.s_g_par_seq)) {
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/group_word/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const refreshWordList = () => {
    list({});
    myProps.refreshData({});
  };

  return (
    <div className="manage-word-popup">
      <WordListArea
        infoArr={infoArr}
        refreshData={refreshWordList}
      />

      <div className="popup-footer mt-3 text-center">
        <button
          className="btn btn-dark"
          onClick={() => myProps.closePopup()}
        >
          닫기
        </button>
      </div>
    </div>
  );
};
export default TextBookManageWordPopupArea;